import React from 'react';
import styles from './TemplateDownload.module.scss';

export const TemplateDownload = () => {
  return (
    <div className={styles.templateDownload}>
      <div className={styles.imagePlaceholder}></div>
      <div className={styles.linksContainer}>
        <div className={styles.linkItem}>
          <p>オリジナルデザインの場合：</p>
          <a href="#">テンプレートのダウンロード</a>
        </div>
        <div className={styles.linkItem}>
          <p>弊社準備のデザインを使用する場合：</p>
          <a href="#">データのダウンロード</a>
        </div>
      </div>
    </div>
  );
}; 